
import './UserManagementPage.css';

/**
 * UserManagementPage (Smart Component / Container)
 * Manages user data and state
 */
export const UserManagementPage = () => {

    return (
        <div className="user-management-page">
            <div className="user-management-page__header">
                <h1 className="user-management-page__title">User Management</h1>
            </div>
        </div>
    );
};
